import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  categories: [],
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalCategories: 0,
    totalPages: 0
  },
  categoriesCatalog: {},
  filterParams: '',
  isModalVisible: false,
  isModalImagesVisible: false
}

const mutations = {
  SET_CATEGORIESS (state, payload) {
    state.categories = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalCategories: payload.total,
      totalPages: payload.last_page
    }
  },
  ADD_CATEGORIES (state, payload) {
    state.categories.unshift(payload)
  },
  SET_MODAL_IMAGES_VISIBLE (state, payload) {
    state.isModalImagesVisible = payload
  },
  UPDATE_CATEGORIES (state, payload) {
    const idx = state.categories.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.categories, idx, payload)
    }
  },
  DELETE_CATEGORIES (state, payload) {
    const idx = state.categories.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.categories, idx)
    }
  },
  DELETE_CATEGORIESS (state, payload) {
    for (let id of payload.ids) {
      const idx = state.categories.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.categories, idx)
      }
    }
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.categoriesCatalog[object] = payload.data
  },
  SET_CATEGORIESS_CATALOG (state, payload) {
    state.categoriesCatalog = { ...state.categoriesCatalog, ...payload }
  }
}

const actions = {
  async loadCategories ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`categories?page=${payload.page}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATEGORIESS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addCategories ({ commit }, payload) {
    const categories = {
      layer_id: payload.layer_id,
      title: payload.title,
      about: payload.about,
      total_price: payload.total_price,
      discount: payload.discount,
      color: payload.color
    }

    app.$Progress.start()

    try {
      const response = await axios.post('categories', categories)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_CATEGORIES', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.categories', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editCategories ({ commit }, payload) {
    const categories = {
      layer_id: payload.layer_id,
      title: payload.title,
      about: payload.about,
      total_price: payload.total_price,
      discount: payload.discount,
      color: payload.color
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`categories/${payload.id}`, categories)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_CATEGORIES', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.categories', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteCategory ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`categories/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_CATEGORIES', payload)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.categories', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteCategories ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`categories/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_CATEGORIESS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.categories', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionCategories ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`categories/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_CATEGORIES', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.categories', text: `categories.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/categories/export?' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteCategoryImage ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`category-image/${payload}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.categories', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      // commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadCategoriesCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`categories/catalog`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.categories', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATEGORIESS_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalImagesVisible ({ commit }, payload) {
    commit('SET_MODAL_IMAGES_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  }
}

const getters = {
  categories: state => state.categories,
  categoriesCatalog: state => state.categoriesCatalog,
  pagination: state => state.pagination,
  isModalVisible: state => state.isModalVisible,
  isModalImagesVisible: state => state.isModalImagesVisible,
  filterParams: state => state.filterParams
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
